import { render, staticRenderFns } from "./SideNavigation.vue?vue&type=template&id=3596263c&scoped=true&"
import script from "./SideNavigation.vue?vue&type=script&lang=js&"
export * from "./SideNavigation.vue?vue&type=script&lang=js&"
import style0 from "./SideNavigation.vue?vue&type=style&index=0&id=3596263c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3596263c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VIcon,VList,VNavigationDrawer,VSpacer})
